import Snap from 'snapsvg-cjs';
import createTriangle from './create-triangle';
import Accordion from './accordion';

const sectionAccordions = () => {
    const accordions = document.querySelectorAll('.js-accordion');
    if (accordions.length !== 0) {
        new Accordion(accordions);
    }
};

export default sectionAccordions;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/kerris-select-chisel/src/scripts/modules/section-accordions.js